import BillStatements from "./BillStatements";
const BillingReport = () => {
    return(
        <>
        <BillStatements/>
        </>
    )
}

export default BillingReport;